<template>
  <div class="calendar">
    <div
      v-for="(slot, index) in timeSlots"
      :key="index"
      :class="['day-card', { selected: selectedTime === slot.value }]"
      @click="selectTime(slot)"
    >
      <div class="day-name">{{ slot.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CalendarTime",
  data() {
    return {
      timeSlots: [],
      selectedTime: null
    };
  },
  created() {
    this.generateTimeSlots();
  },
  methods: {
    generateTimeSlots() {
      const startHour = 9;
      const endHour = 20;
      const interval = 30; // دقائق

      const slots = [];

      const pad = (num) => String(num).padStart(2, '0');

      for (let h = startHour; h <= endHour; h++) {
        for (let m = 0; m < 60; m += interval) {
          const hour = pad(h);
          const minute = pad(m);
          const value = `${hour}:${minute}`;

          // نتأكد ما نضيف 22:00
          if (h === endHour && m > 30) break;

          slots.push({
            value,
            label: `${value}` // فيك تضيف AM/PM أو صيغة عربية
          });
        }
      }

      this.timeSlots = slots;
    },
    selectTime(slot) {
      this.selectedTime = slot.value;
      this.$emit("time-selected", slot.value);
    }
  }
};
</script>

<style scoped>
.calendar {
    margin-top: 1rem;
  display: flex;
  width: 100%;
  gap: 12px;
  overflow-x: auto;
  direction: rtl;
}
.day-card {
  border: 1px solid #014342;
  border-radius: 10px;
  padding: 12px;
  text-align: center;
  background: #f9f9f9;
  min-width: 100px;
  cursor: pointer;
}
.day-name {
  font-weight: 500;
  color: #000;
}
.selected {
  background-color: #014342;
  border: 1px solid #014342;
  border-radius: 10px;
  padding: 12px;
  text-align: center;
  min-width: 100px;
}
.selected .day-name {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/CalendarTime.vue